<a mat-stroked-button i18n="@@cart-view-purchase-options.view-options.label" [routerLink]="['/products', productId()?.toString()]"
  >View Options</a
>
@let count = cartItemCount();
@if (count > 0) {
  <div options-selected i18n="@@cart-view-purchase-options.options-selected.text">
    You have {{ count | number }} {{ count | i18nPlural: optionsPluralMap }} selected
  </div>
}
